import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
    baseURL: API_URL || '',
    headers: {'Content-Type': 'application/json', },
    withCredentials: true,
});

export const setupCsrf = async () => {
    try {
        const { data } = await api.get('/api/csrf-token');
        api.defaults.headers.common['x-csrf-token'] = data.csrfToken;
    } 
    catch(error){ console.error('Failed to fetch CSRF token:', error); }
};

export const resetSessionController = () => { delete api.defaults.headers.common['x-csrf-token']; };

// Phase 4: CSRF Token Refresh — auto-refresh on 403 and periodic refresh
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Global 429 Rate Limit Handling
        if (error.response?.status === 429) {
            const retryAfter = error.response.headers['retry-after'];
            window.dispatchEvent(new CustomEvent('api-429-error', { 
                detail: { retryAfter } 
            }));
            // Reject the promise so the specific request knows it failed
            return Promise.reject(error);
        }

        // If 403 (CSRF/token error) and not already retried
        if (error.response?.status === 403 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const { data } = await api.get('/api/csrf-token');
                api.defaults.headers.common['x-csrf-token'] = data.csrfToken;
                originalRequest.headers['x-csrf-token'] = data.csrfToken;
                return api(originalRequest); // Retry the original request
            } catch (refreshError) {
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

// Periodic CSRF token refresh every 30 minutes
setInterval(async () => {
    try {
        const { data } = await api.get('/api/csrf-token');
        api.defaults.headers.common['x-csrf-token'] = data.csrfToken;
    } catch (e) {
        console.warn('CSRF token refresh failed:', e);
    }
}, 30 * 60 * 1000);

/* 
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if(token){ config.headers['Authorization'] = `Bearer ${token}`; }
        return config;
    },
    (error) => { return Promise.reject(error); }
);
 */
export default api;
